export const APPLE_PAY_PAYMENT_METHOD_NAME = "ApplePay";
export const APPLEPPAYPAYMENTMETHODWALLETSOURCE = "APPLEPAY";
